
import React, { useState } from 'react';
import { Button } from '@mui/material';
import TestPrintPreviewMobile from './TestPrintPreviewMobile';

export default function TestPrint() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Open Print Preview
      </Button>
      <TestPrintPreviewMobile open={open} onClose={() => setOpen(false)} />
    </>
  );
}
